export default {
    title: "O-I",
    support: "Supporto",
    dashboard: "Pannello di controllo"
}